export default function(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}